import m from "./module";
import { LogicModifier } from "../model/LogicModifier";
import {
  logicOptions,
  logicOptionsWithoutComparisons,
  dateLogicOptions,
} from "../model/LogicCondition";
import { createError } from "../error";
import { formatAsTimeString } from "../dateutil";

class LogicModifierService {
  constructor($injector, $q, DateTimeService, LogService) {
    "ngInject";
    this.$injector = $injector;
    this.$q = $q;
    this.DateTimeService = DateTimeService;
    this.LogService = LogService;
  }

  create(data) {
    data = data || {};
    let target_id = data.target_id || null;
    if (!target_id) {
      target_id = data.references_events_custom_instances_id || null;
    }
    data.target_id = target_id;

    return new LogicModifier(data);
  }

  serialize(logicModifier) {
    const targetFieldType =
      logicModifier &&
      logicModifier.target &&
      logicModifier.target.field &&
      logicModifier.target.field.fieldType;

    /**
     * Serialize date/time for API; removes timezone
     */
    let serializedValue = logicModifier.value;
    if (targetFieldType && targetFieldType.isDateTime) {
      serializedValue = this.DateTimeService.serializeDateTimeForAPI(
        logicModifier.value
      );
    } else if (targetFieldType && targetFieldType.isTime) {
      serializedValue = formatAsTimeString(logicModifier.value, true);
      this.LogService.debug(
        `LogicModifierService.serialize() input: ${logicModifier.value} output: ${serializedValue}`
      );
    } else if (targetFieldType && targetFieldType.isDate) {
      serializedValue = this.DateTimeService.serializeDateForAPI(
        logicModifier.value
      );
    }

    return {
      id: logicModifier.id,
      references_events_custom_instances_id: (logicModifier.target && logicModifier.target.id) || logicModifier.target_id,
      logic: logicModifier.logic,
      value: serializedValue,
      selected_events_custom_options_id: logicModifier.selected_events_custom_options_id,
      truthy_values: logicModifier.truthy_values.map((value) => value.id),
      falsy_values: logicModifier.falsy_values.map((value) => value.id),
    };
  }

  describeLogic(logic) {
    if (logic in this.logicOptions) {
      return this.logicOptions[logic];
    } else {
      return logic;
    }
  }

  get logicOptions() {
    return logicOptions;
  }

  get dateLogicOptions() {
    return dateLogicOptions;
  }

  get logicOptionsWithoutComparisons() {
    return logicOptionsWithoutComparisons;
  }

  updateTargetForLogicModifier(logicModifier) {
    return this.$q
      .when(logicModifier.target_id)
      .then((target_id) => {
        if (target_id) {
          const FieldInstanceService = this.$injector.get("FieldInstanceService");
          return FieldInstanceService.getById(target_id);
        } else {
          return this.$q.reject(
            createError({
              error: "MissingTargetForLogicModifier",
              message: "Logic modifier has no target ID",
              logicModifier,
            })
          );
        }
      })
      .then((targetFieldInstance) => {
        logicModifier.target = targetFieldInstance;
        return this.$q
          .when(
            this.updateValueForLogicModifierWithTarget(
              logicModifier,
              targetFieldInstance
            )
          )
          .then(() => targetFieldInstance);
      })
      .catch((err) => {
        this.LogService.warn(
          "Error retrieving target field instance or updating value:",
          err
        );
      });
  }

  updateValueForLogicModifierWithTarget(logicModifier, targetFieldInstance) {
    const field = targetFieldInstance && targetFieldInstance.field;
    const fieldType = field && field.fieldType;

    if (field && field.hasOptions() && logicModifier.selected_events_custom_options_id) {
      // Find selected option if it exists, and populate
      logicModifier.valueOption = targetFieldInstance.field.options.find(
        (option) => parseInt(option.id) === parseInt(logicModifier.selected_events_custom_options_id)
      );
    }
  }
}

export default LogicModifierService;

m.service("LogicModifierService", LogicModifierService);
